import {ListView, ListViewItemProps} from "@progress/kendo-react-listview"
import dayjs from "dayjs"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"

type TestDefect = {
    annualTestDefectId: number
    annualTestId: number
    failureItemNo: number
    failureReason: string
    severityCode: string
    severityDescription: string
}

export default function MotAnnualTests(): JSX.Element {
    const annualTests = useAppSelector((state: RootState) => state.containers.motHistory.annualTests)
    const vehicleDetails = useAppSelector((state: RootState) => state.containers.motHistory.vehicleDetails)

    const MyItemRender = (props: ListViewItemProps) => {
        let item: {
            testType: string
            testDate: Date
            testResult: string
            expiryDate: Date
            testCertificateNumber: string
            location: string
            defects: TestDefect[]
        } = props.dataItem

        return (
            <>
                <div
                    className="row p-2 pt-3 pb-3 border-bottom align-middle"
                    style={{
                        margin: 0,
                    }}
                >
                    <div className="col-3 p-2 pt-0">
                        <p className="m-0">Date tested</p>
                        <p className="m-0">
                            <b className="text-muted">
                                {/* {new Date(item.testDate).toLocaleDateString("en-GB", {
                                    year: "numeric",
                                    month: "long",
                                    day: "2-digit",
                                })} */}
                                {dayjs(item.testDate).format("DD MMMM YYYY")}
                            </b>
                        </p>
                        <h5
                            className={`font-weight-bold text-uppercase text-${
                                item.testResult === "PASSED"
                                    ? "success"
                                    : "danger"
                            }`}
                        >
                            {item.testResult}
                        </h5>
                    </div>
                    <div className="col-9">
                        <div className="row mb-4">
                            <div className="col-6">
                                <p className="mb-2">Expiry Date</p>
                                <div className="font-weight-bold text-muted">
                                    {/* {new Date(item.expiryDate).toLocaleDateString("en-GB", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                    })} */}
                                    {dayjs(item.expiryDate).format("DD/MM/YYYY")}
                                </div>
                            </div>
                            <div className="col-6">
                                <p className="mb-2">Mot Number</p>
                                <div className="font-weight-bold text-muted">{item.testCertificateNumber}</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p className="mb-2">Location</p>
                                <div className="font-weight-bold text-muted">{item.location}</div>
                            </div>
                        </div>
                        {item.defects.length > 0 && (
                            <div className="row pt-3">
                                <div className="col-12 mt-2">
                                    {[...Array.from(new Set<string>(item.defects.map(t => t.severityCode)))].map(
                                        (t, index) => (
                                            <div key={index}>
                                                <p className="mb-2 ">
                                                    {item.defects.find(f => f.severityCode === t)?.severityDescription}(
                                                    {t})
                                                </p>
                                                <ul className="mb-1">
                                                    {item.defects
                                                        .filter(f => f.severityCode === t)
                                                        .map((f, failureIndex) => (
                                                            <li
                                                                key={failureIndex}
                                                                className="font-weight-bold text-muted"
                                                            >
                                                                {f.failureReason}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        ),
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            <div className="row p-2 pt-3 bg-white m-0">
                <div className="col-12">
                    <h3 className="text-muted">{vehicleDetails.registration}</h3>
                    <h5 className="text-muted">
                        {vehicleDetails.make} {vehicleDetails.model}
                    </h5>
                </div>
            </div>
            <div className="row p-2 bg-white m-0 pb-3 mb-2 border-bottom">
                <div className="col-3">
                    <p className="mb-2">Vehicle Type</p>
                    <b className="text-muted">{vehicleDetails.vehicleType}</b>
                </div>
                <div className="col-3">
                    <p className="mb-2">Vehicle Class</p>
                    <b className="text-muted">{vehicleDetails.vehicleClass}</b>
                </div>
                <div className="col-3">
                    <p className="mb-2">Date Registered</p>
                    <b className="text-muted">
                        {vehicleDetails.registrationDate
                            ? // ? new Date(vehicleDetails.registrationDate).toLocaleDateString("en-GB", {
                              //       year: "numeric",
                              //       month: "long",
                              //       day: "2-digit",
                              //   })
                              dayjs(vehicleDetails.registrationDate).format("DD MMMM YYYY")
                            : "NA"}
                    </b>
                </div>
                <div className="col-3">
                    <p className="mb-2">Expiry Date</p>
                    <b className="font-weight-bold text-muted">
                        {vehicleDetails.annualTestExpiryDate
                            ? // ? new Date(vehicleDetails.annualTestExpiryDate).toLocaleDateString("en-GB", {
                              //       year: "numeric",
                              //       month: "long",
                              //       day: "2-digit",
                              //   })
                              dayjs(vehicleDetails.annualTestExpiryDate).format("DD MMMM YYYY")
                            : "NA"}
                    </b>
                </div>
            </div>
            <ListView
                data={annualTests}
                item={MyItemRender}
                style={{
                    width: "100%",
                }}
            />
        </>
    )
}
